import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';

HelmetSEO.propTypes = {
  display: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  total: PropTypes.number,
};

function HelmetSEO(props) {
  const {display, location} = props;
  let total = 'Many';
  if (props?.total) total = props.total;
  const agentDisplay = (display === 'agencies') ? 'Agencies' : 'Agents';
  const agentChooseDisplay = (display === 'agencies') ? 'agency' : 'agent';

  return (
    <Helmet>
      <title>{total + ' Real Estate ' + agentDisplay + ' active in ' + location.suburb + ', '  + location.stateCode + ' ' + location.postcode + ' | OnTheHouse'}</title>
      <meta name="description" content={'Find real estate ' + agentDisplay.toLowerCase() + ' in ' + location.suburb + ', ' + location.stateCode + ' ' + location.postcode + '. View listings & sales performance for ' + total + ' active real estate ' + agentDisplay.toLowerCase() + ' & choose the right ' + agentChooseDisplay + ' for you with OnTheHouse'} />
    </Helmet>
  );
}

export default HelmetSEO;
